import { useState } from "react";
import { Button, Col, Modal, Row, Tab, Tabs } from "react-bootstrap";
import useCustomer from "../../context/CustomerContext";
import { useDeleteCustomerMutation, useGetCustomerQuery } from "../../features/customer/customerSlice";
import Spinner from "../Spinner";
import Contract from "./Contract";
import Invoice from "./Invoicing";
import CustomerInfo from "./NameAddress/CustomerDetails";
import EditCustomer from "./NameAddress/EditNameAddress";
import SaveCustomer from "./NameAddress/SaveNameAddress";

const CustomerDetailstab = () => {
  const { refetch } = useGetCustomerQuery()
  const [deleteCustomer] = useDeleteCustomerMutation()
  const { selected, singleAccount, isLoading, validateNameAddress, createCustomerIsLoading } = useCustomer();
  const account = singleAccount && singleAccount[0];
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEditName, setShowEditName] = useState(true);
  const [key, setKey] = useState("name");

  function refreshPage() { window.location.reload(false); }
  const deleteCustomerList = async (account) => {
    await deleteCustomer(account?.account_No)
    refetch()
  }
  const showhandler = () => { setShowEditName(!showEditName); }


  return (
    <>
      <Row>
        <Col>
          <h4>
            {selected ? account?.customer : "Customer name"}
          </h4>
        </Col>
        <Col xs="auto">
          {selected ?
            <Button variant="danger" onClick={handleShow} >
              Delete Customer
            </Button>
            :
            <Button variant="primary" onClick={() => validateNameAddress()}  >
              {!createCustomerIsLoading ? "Add Customer" : <Spinner />}
            </Button>
          }
        </Col>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete the selected customer?</Modal.Body>
          <Modal.Footer>
            <Row>
              <Col sm={6}>
                <Button variant="secondary" onClick={handleClose}>
                  CANCEL
                </Button>
              </Col>
              <Col sm={6}>
                <Button variant="primary" onClick={e => { deleteCustomerList(account); refreshPage() }}>
                  DELETE
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      </Row >

      {isLoading && <Spinner />}
      <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
        {showEditName ?
          <Tab eventKey="name" title="Name/Address">
            {selected ?
              <EditCustomer showhandler={showhandler} /> :
              <CustomerInfo />}
          </Tab>
          : <Tab eventKey="name" title="Name/Address">
            <SaveCustomer showhandler={showhandler} />
          </Tab>}

        {selected ?
          <Tab eventKey="contract" title="Contract/Pricing">
            <Contract />
          </Tab> : null}
        {selected ? <Tab eventKey="invoicing" title="Invoicing" >
          <Invoice />
        </Tab> : null}
      </Tabs>
    </>
  );
};
export default CustomerDetailstab;
